<template>
    <div class="verifForm">
    <v-card
        class="mx-auto pa-12 pb-8 card-ve"
        elevation="8"
        width="448"
        rounded="lg"
      >
      <p style="font-size: 18px">We sent verification code to your e-mail.<br>Enter the code to get free search.<br>⚠️ You have 5 tries, check your spam ⚠️<br><br></p>

    <v-text-field v-model="verificationCode" label="Verification code" required></v-text-field>
    <v-row class="d-flex align-center">
      <v-col cols="auto">
        <v-btn color="blue"  variant="tonal" @click="verifyPhoneNumber" >Check the code</v-btn>
        <v-btn color="blue"  variant="tonal" @click="resendCode" style="margin-left: 20px;" >Resend</v-btn>
      </v-col>
    </v-row>

    </v-card>
  
  </div> 
  </template>

<style>
.card-ve{
  background-color: #111111;
}
.verifForm{
    display: flex;
    align-items: center; 
    justify-content: center;
    height: 100vh;  
  }
</style>
<script>
import { useToast } from "vue-toastification";
import { mapGetters } from 'vuex';
  
  export default {
    data() {
      return {
        verificationCode: '',
      };
    },
    computed: {
      ...mapGetters(['backend']),
    },

    methods: {
      async verifyPhoneNumber() {
        const toast = useToast();
        try {
          const token = localStorage.getItem("Authorization");
          const response = await this.$axios.post(`${this.backend}/api/user/verification`, {verificationCode: this.verificationCode}, {
            headers: {"Authorization": token}
          });
          if (response.status === 200) {
            const userdata2 = JSON.parse(localStorage.getItem('userdata'))
            userdata2.research = 1
            localStorage.setItem('userdata', JSON.stringify(userdata2))
            document.location = "/"
          }
        } catch (err) {
          toast.error((err.response.data.error).toString());
        }
      },
      async resendCode() {
        const toast = useToast()
        try {
          const token = localStorage.getItem("Authorization");
          let response = await this.$axios.get(`${this.backend}/api/user/resend_code`, {headers: {"Authorization": token}});
          if (response.status === 200) {
            toast.success(response.data.message)
          }
        } catch (err) {
          toast.error((err.response.data.error).toString());
        }
      }
    },
};
</script>
  